import React from 'react';

import classes from './WhatYouWillGet.module.scss';

const WhatYouWillGet = () => {
    return (
        <section className={`${classes['wrapper']}`}>
            <div className="container d-flex flex-column align-items-center w-100">
                <div className="row flex-column align-items-center justify-content-center w-100">
                    <h2>Unlock premium benefits</h2>
                    <p>
                        With Pharmuni Premium, elevate your pharma expertise with 40+ standard courses and quizzes and an AI-powered skill tree tailored to your growth.
                        Unlock VIP consultations, plus pharma-focused resume and cover letter builders, to refine your professional edge.
                    </p>
                </div>
                <div className={classes['cards-wrapper']}>
                    <div className="row mt-5">
                        <div className="col-xl-6 col-12">
                            <a href='https://pharmuni.com/pharmuni-certificate/'>
                                <div className={`${classes['image-card']} ${classes['image-first']}`}>
                                    <span>
                                        Access to
                                    </span>
                                    <h3>
                                        All course content with industry recognized certificate
                                    </h3>
                                </div>
                            </a>
                        </div>
                        <div className="col-xl-6 col-12 mt-xl-0 mt-4">
                            <a href='https://pharmuni.com/skill-tree/'>
                                <div className={`${classes['image-card']} ${classes['image-second']}`}>
                                    <span>
                                        Watch your progress on
                                    </span>
                                    <h3>
                                        AI Based Skill Tree
                                    </h3>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-xl-8 col-12">
                            <a href='https://pharmuni.com/resume-builder/'>
                                <div className={`${classes['image-card']} ${classes['image-third']}`}>
                                    <span>
                                        Access to
                                    </span>
                                    <h3>
                                        Public profile and<br /> Resume builder
                                    </h3>
                                </div>
                            </a>
                        </div>
                        <div className="col-xl-4 col-12  mt-xl-0 mt-4">
                            <a href='https://pharmuni.com/vip-consultation-meeting/'>
                                <div className={`${classes['image-card']} ${classes['image-fourth']}`}>
                                    <span>
                                        Request
                                    </span>
                                    <h3>
                                        Consultation<br /> meeting
                                    </h3>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-xl-6 col-12">
                            <a href='https://pharmuni.com/cover-letter-builder/'>
                                <div className={`${classes['image-card']} ${classes['image-fifth']}`}>
                                    <span>
                                        Create your own
                                    </span>
                                    <h3>
                                        Cover Letter
                                    </h3>
                                </div>
                            </a>
                        </div>
                        <div className="col-xl-6 col-12  mt-xl-0 mt-4">
                            <div className={`${classes['image-card']} ${classes['image-sixth']}`}>
                                <span>
                                    Access to
                                </span>
                                <h3>
                                    Pharmaceutical job board and track your applications
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhatYouWillGet;